<section class="dashboard">
  <div class="dashboard-main">
    <header class="dashboard-header">
      <div>
        <h1>Own Jobs</h1>
      </div>
      <div class="header-right">
        <input
          class="search"
          type="search"
          placeholder="Search jobs…"
          [value]="search()"
          (input)="setSearch($any($event.target).value)"
        />
        <span class="dashboard-date">{{ todayLabel }}</span>
      </div>
    </header>

    @if (loading()) {
      <mat-progress-bar
        mode="indeterminate"
        class="page-progress"
      ></mat-progress-bar>
    }
    @if (downloading()) {
      <mat-progress-bar
        mode="indeterminate"
        color="accent"
        class="page-progress"
      ></mat-progress-bar>
    }

    <div class="stats-row">
      <div class="stat-card">
        <div class="stat-value">
          {{ projectStats().inProgress }}
        </div>
        <div class="stat-label">In Progress</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">
          {{ projectStats().complete }}
        </div>
        <div class="stat-label">Complete</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ projectStats().total }}</div>
        <div class="stat-label">Total</div>
      </div>
      <a class="stat-action" routerLink="/customers/new">New Customer</a>
    </div>

    @if (message(); as message) {
      @if (message) {
        <div class="status">{{ message }}</div>
      }
    }

    <div class="tabs">
      @for (tab of tabs; track tab.value) {
        <button
          class="tab-btn"
          [class.active]="activeTab() === tab.value"
          (click)="selectTab(tab.value)"
        >
          {{ tab.label }}
        </button>
      }
    </div>

    @let cards = pageRows();
    @if (cards.length > 0) {
      <div class="list">
        <div class="list-head">
          <span>Customer</span>
          <span>Status</span>
          <span class="num">Rooms</span>
          <span class="num">Blinds</span>
          <span>Progress</span>
          <span>Started</span>
          <span>Actions</span>
          <span></span>
        </div>
        @for (project of cards; track project.id) {
          <div
            class="list-row"
            [routerLink]="['/customers', project.id]"
            style="cursor: pointer"
          >
            <span class="cell customer">
              <span class="strong">{{ project.title }}</span>
              @if (project.isRemake) {
                <span class="remake-badge">🔁 Remake</span>
              }
            </span>
            <span class="cell">
              @if (project.status) {
                <span class="status-badge">{{ project.status }}</span>
              }
              @if (project.archivedAt) {
                <span class="status-badge">Archived</span>
              }
            </span>
            <span class="cell num" data-label="Rooms">{{ project.roomsCount }}</span>
            <span class="cell num" data-label="Blinds">{{ project.windowsCount }}</span>
            <span class="cell progress-cell">
              <span class="bar"><span [style.width.%]="project.progress"></span></span>
              <span class="muted">{{ project.progress }}%</span>
            </span>
            <span class="cell muted" data-label="Started">{{ project.dateLabel }}</span>
            <span class="cell actions">
              <button
                class="btn-mini"
                (click)="$event.stopPropagation(); downloadBlindsReport(project.id)"
                title="Download Measurements CSV"
                type="button"
                [disabled]="downloading()"
              >
                Measurements
              </button>
              <button
                class="btn-mini"
                (click)="$event.stopPropagation(); downloadEstimatePDF(project.id)"
                title="Download Estimate PDF"
                type="button"
                [disabled]="downloading()"
              >
                Estimate
              </button>
              @if (project.archivedAt) {
                <button
                  class="btn-mini"
                  (click)="$event.stopPropagation(); restore(project.id)"
                  title="Restore job"
                  type="button"
                  [disabled]="restoringId() === project.id"
                >
                  Restore
                </button>
              }
            </span>
            <span class="cell chev">›</span>
          </div>
        }
      </div>

      <footer class="pager">
        <span class="pager-info">{{ projectCards().length }} jobs</span>
        <div class="pager-controls">
          <button type="button" (click)="setPage(-1)" [disabled]="page() === 0">
            ‹ Prev
          </button>
          <span class="pager-page">{{ page() + 1 }} / {{ pageCount() }}</span>
          <button
            type="button"
            (click)="setPage(1)"
            [disabled]="page() >= pageCount() - 1"
          >
            Next ›
          </button>
        </div>
      </footer>
    } @else {
      @if (!loading()) {
        <div class="empty-state">
          No customers yet. Create one to get started.
        </div>
      }
    }
  </div>
</section>
